export const requestPushPermission = async () => { 
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  return await Notification.requestPermission();
};

export const showPush = (data) => {
  if (!("Notification" in window)) return;

  if (Notification.permission !== "granted") {
    console.warn("Notification non autorisée");
    return;
  }

  new Notification("Notification Deal.mg", {
    body: data?.message || "Vous avez une nouvelle notification",
    icon: "/logo-chariot-1.png",
  });
};
